var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-message"},[_vm._v(" © "+_vm._s(_vm.year)+" sales.ai - Crafted with "),_c('i',{staticClass:"fa fa-heart"}),_vm._v(" in Solihull, UK. ")])}
var staticRenderFns = []

export { render, staticRenderFns }